export default {
  usedPlayerIds(store) {
    if (store.kickIndex !== null && store.kickUsedPlayerIds[store.kickIndex]) {
      return store.kickUsedPlayerIds[store.kickIndex];
    }

    if (!store.usedPlayerKey || !store[store.usedPlayerKey]) return [];

    return store[store.usedPlayerKey];
  },
};



// WEBPACK FOOTER //
// ./src/store/matches-editor/getters.js